(() => {
  'use strict';
  if (window.__sdReviewsRepair) return;
  window.__sdReviewsRepair = true;

  const REVIEW_RE = /(\d[\d,]*)\s+reviews?\b/i;

  function countFor(badge) {
    if (!badge) return 0;
    const raw = badge.getAttribute('data-number-of-reviews');
    if (raw != null && raw !== '') {
      const parsed = Number(String(raw).replace(/,/g, ''));
      if (Number.isFinite(parsed)) return parsed;
    }
    const match = (badge.textContent || '').replace(/\s+/g, ' ').match(REVIEW_RE);
    return match ? Number(match[1].replace(/,/g, '')) : 0;
  }

  function kickJudgeMe() {
    if (window.jdgm && typeof window.jdgm.initWidgets === 'function') {
      try { window.jdgm.initWidgets(); } catch (_) {}
    }
  }

  function productRoots() {
    return Array.from(document.querySelectorAll('[data-sdp-product], .sdp-product'));
  }

  function repairReviews() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    productRoots().forEach((root) => {
      const preview = root.querySelector('.jdgm-preview-badge');
      const badge = root.querySelector('.jdgm-prev-badge');
      const reviews = root.querySelector('.sdp-reviews');
      const widget = reviews && reviews.querySelector('.jdgm-review-widget');
      const count = countFor(badge);

      if (reviews && reviews.id !== 'ShadowsProductReviews') reviews.id = 'ShadowsProductReviews';
      if (widget) {
        widget.hidden = false;
        widget.removeAttribute('aria-hidden');
      }

      if (count > 0 && badge) {
        badge.hidden = false;
        badge.removeAttribute('aria-hidden');
        if (preview) {
          preview.hidden = false;
          preview.removeAttribute('aria-hidden');
        }

        let link = root.querySelector('.sd-review-link');
        if (!link) {
          link = document.createElement('a');
          link.className = 'sd-review-link';
          if (preview) preview.insertAdjacentElement('afterend', link);
          else if (badge.parentElement) badge.parentElement.appendChild(link);
        }
        const label = `Read all ${count} reviews`;
        if (link.getAttribute('href') !== '#ShadowsProductReviews') link.setAttribute('href', '#ShadowsProductReviews');
        if (link.textContent !== label) link.textContent = label;
        link.hidden = false;
        link.removeAttribute('aria-hidden');
      } else if (badge && badge.getAttribute('data-number-of-reviews') === '0') {
        const link = root.querySelector('.sd-review-link');
        if (link) link.remove();
      }
    });
  }

  let queued = false;
  function scheduleRepair() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      repairReviews();
    });
  }

  function bindScopedObservers() {
    productRoots().forEach((root) => {
      if (root.dataset.sdReviewsObserver === '1') return;
      root.dataset.sdReviewsObserver = '1';
      const observer = new MutationObserver(scheduleRepair);
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-number-of-reviews']
      });
    });
  }

  function boot() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    kickJudgeMe();
    repairReviews();
    bindScopedObservers();

    [250, 900, 2200, 4500].forEach((ms) => {
      window.setTimeout(() => {
        kickJudgeMe();
        repairReviews();
        bindScopedObservers();
      }, ms);
    });

    document.addEventListener('shopify:section:load', () => {
      kickJudgeMe();
      repairReviews();
      bindScopedObservers();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
